import React from 'react';
import { Tooltip as CommonTooltip } from '@blueprintnyc/bpnyc-common-admin';

import './Tooltip.scss';

const Tooltip = props => {
	const { learnMoreOnClick, content } = props;
	const newContent = learnMoreOnClick ? (
		<div className="content" key={content}>
			{content}
			<div className="learn-more" onClick={learnMoreOnClick}>
				(learn more)
			</div>
		</div>
	) : (
		content
	);
	return <CommonTooltip {...props} content={newContent} />;
};

export default Tooltip;
